export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8234.46df8f7e.jpg";